import { User, UserStats } from 'types';

export const MOCK_USERS: User[] = [
  {
    id: '1',
    name: 'Иванова Анна Сергеевна',
    email: 'ivanova@absolut.ru',
    role: 'lawyer',
    avatarInitials: 'АИ',
    projectId: '',
    roleId: '',
    isDemo: true,
  },
  {
    id: '2',
    name: 'Петров Михаил Владимирович',
    email: 'petrov@absolut.ru',
    role: 'lawyer',
    avatarInitials: 'МП',
    projectId: '',
    roleId: '',
    isDemo: true,
  },
  {
    id: '3',
    name: 'Смирнова Ольга Игоревна',
    email: 'smirnova@absolut.ru',
    role: 'hr',
    avatarInitials: 'ОС',
    projectId: '',
    roleId: '',
    isDemo: true,
  },
  {
    id: '4',
    name: 'Волков Андрей Николаевич',
    email: 'volkov@absolut.ru',
    role: 'ops',
    avatarInitials: 'АВ',
    projectId: '',
    roleId: '',
    isDemo: true,
  },
  {
    id: '5',
    name: 'Администратор',
    email: 'admin@absolut.ru',
    role: 'admin',
    avatarInitials: 'AD',
    projectId: '',
    roleId: '',
    isDemo: true,
  },
];

export const AVAILABLE_MODELS = [
  { value: 'GPT-OSS-120B', label: 'GPT-OSS-120B' },
  { value: 'Gemma4-26B-MoE', label: 'Gemma4-26B-MoE' },
  { value: 'Gemma4-E4B', label: 'Gemma4-E4B' },
];

export const findUserByEmail = (email: string): User | undefined =>
  MOCK_USERS.find((u) => u.email === email);

export const USER_STATS: Record<string, UserStats> = {
  '1': {
    userId: '1',
    totalRequests: 247,
    requestsDelta: 18,
    tokensUsed: 1200000,
    tokenLimit: 2000000,
    documentsProcessed: 84,
    avgResponseTime: 4.8,
    activeDays: 18,
    weekActivity: [
      { day: 'Пн', count: 12 },
      { day: 'Вт', count: 21 },
      { day: 'Ср', count: 15 },
      { day: 'Чт', count: 28 },
      { day: 'Пт', count: 19 },
      { day: 'Сб', count: 6 },
      { day: 'Вс', count: 1 },
    ],
    scenarioStats: [
      { scenarioId: 'summarize-doc', title: 'Суммаризация', requests: 98, tokens: 520000 },
      { scenarioId: 'extract-tasks', title: 'Поручения', requests: 64, tokens: 310000 },
      { scenarioId: 'business-reply', title: 'Деловой ответ', requests: 52, tokens: 240000 },
      { scenarioId: 'compare-docs', title: 'Сравнение', requests: 33, tokens: 130000 },
    ],
    feed: [
      {
        id: 'f1-1',
        scenarioId: 'summarize-doc',
        scenarioTitle: 'Суммаризация',
        fileName: 'договор_аренды_2024.pdf',
        time: '14:32',
        color: '#6366f1',
      },
      {
        id: 'f1-2',
        scenarioId: 'extract-tasks',
        scenarioTitle: 'Поручения',
        fileName: 'протокол_совещания.docx',
        time: '11:10',
        color: '#10b981',
      },
      {
        id: 'f1-3',
        scenarioId: 'business-reply',
        scenarioTitle: 'Деловой ответ',
        fileName: 'запрос_№145.pdf',
        time: 'Вчера',
        color: '#f59e0b',
      },
      {
        id: 'f1-4',
        scenarioId: 'compare-docs',
        scenarioTitle: 'Сравнение',
        fileName: 'договор_v1 vs v2',
        time: '12 апр',
        color: '#6366f1',
      },
      {
        id: 'f1-5',
        scenarioId: 'summarize-doc',
        scenarioTitle: 'Суммаризация',
        fileName: 'регламент_закупок.pdf',
        time: '10 апр',
        color: '#6366f1',
      },
    ],
    monthTokens: [
      { month: 'Апрель', used: 1200000 },
      { month: 'Март', used: 980000 },
      { month: 'Февраль', used: 650000 },
    ],
  },
  '2': {
    userId: '2',
    totalRequests: 134,
    requestsDelta: 7,
    tokensUsed: 650000,
    tokenLimit: 1500000,
    documentsProcessed: 41,
    avgResponseTime: 5.2,
    activeDays: 12,
    weekActivity: [
      { day: 'Пн', count: 5 },
      { day: 'Вт', count: 9 },
      { day: 'Ср', count: 14 },
      { day: 'Чт', count: 11 },
      { day: 'Пт', count: 8 },
      { day: 'Сб', count: 0 },
      { day: 'Вс', count: 0 },
    ],
    scenarioStats: [
      { scenarioId: 'compare-docs', title: 'Сравнение', requests: 54, tokens: 290000 },
      { scenarioId: 'summarize-doc', title: 'Суммаризация', requests: 42, tokens: 210000 },
      { scenarioId: 'business-reply', title: 'Деловой ответ', requests: 38, tokens: 150000 },
    ],
    feed: [
      {
        id: 'f2-1',
        scenarioId: 'compare-docs',
        scenarioTitle: 'Сравнение',
        fileName: 'договор_поставки_v3.pdf',
        time: '16:05',
        color: '#6366f1',
      },
      {
        id: 'f2-2',
        scenarioId: 'summarize-doc',
        scenarioTitle: 'Суммаризация',
        fileName: 'устав_ООО_Альфа.pdf',
        time: '13:20',
        color: '#6366f1',
      },
      {
        id: 'f2-3',
        scenarioId: 'business-reply',
        scenarioTitle: 'Деловой ответ',
        fileName: 'претензия_от_11.04.docx',
        time: 'Вчера',
        color: '#f59e0b',
      },
    ],
    monthTokens: [
      { month: 'Апрель', used: 650000 },
      { month: 'Март', used: 510000 },
      { month: 'Февраль', used: 380000 },
    ],
  },
  '3': {
    userId: '3',
    totalRequests: 89,
    requestsDelta: -3,
    tokensUsed: 420000,
    tokenLimit: 1000000,
    documentsProcessed: 29,
    avgResponseTime: 3.9,
    activeDays: 8,
    weekActivity: [
      { day: 'Пн', count: 3 },
      { day: 'Вт', count: 7 },
      { day: 'Ср', count: 4 },
      { day: 'Чт', count: 0 },
      { day: 'Пт', count: 5 },
      { day: 'Сб', count: 0 },
      { day: 'Вс', count: 0 },
    ],
    scenarioStats: [
      { scenarioId: 'analyze-resume', title: 'Анализ резюме', requests: 47, tokens: 220000 },
      { scenarioId: 'create-offer', title: 'Составить оффер', requests: 26, tokens: 120000 },
      {
        scenarioId: 'hr-policy-search',
        title: 'Поиск в HR-политиках',
        requests: 16,
        tokens: 80000,
      },
    ],
    feed: [
      {
        id: 'f3-1',
        scenarioId: 'analyze-resume',
        scenarioTitle: 'Анализ резюме',
        fileName: 'резюме_Соколова_ИВ.pdf',
        time: '10:15',
        color: '#10b981',
      },
      {
        id: 'f3-2',
        scenarioId: 'create-offer',
        scenarioTitle: 'Составить оффер',
        fileName: 'оффер_старший_юрист.docx',
        time: '09:40',
        color: '#10b981',
      },
      {
        id: 'f3-3',
        scenarioId: 'hr-policy-search',
        scenarioTitle: 'Поиск в HR-политиках',
        fileName: 'политика_отпусков_2024.pdf',
        time: '12 апр',
        color: '#10b981',
      },
    ],
    monthTokens: [
      { month: 'Апрель', used: 420000 },
      { month: 'Март', used: 390000 },
      { month: 'Февраль', used: 310000 },
    ],
  },
  '4': {
    userId: '4',
    totalRequests: 201,
    requestsDelta: 24,
    tokensUsed: 980000,
    tokenLimit: 1500000,
    documentsProcessed: 67,
    avgResponseTime: 5.6,
    activeDays: 16,
    weekActivity: [
      { day: 'Пн', count: 10 },
      { day: 'Вт', count: 18 },
      { day: 'Ср', count: 22 },
      { day: 'Чт', count: 17 },
      { day: 'Пт', count: 25 },
      { day: 'Сб', count: 4 },
      { day: 'Вс', count: 0 },
    ],
    scenarioStats: [
      { scenarioId: 'ops-kpi-report', title: 'Операционный отчёт', requests: 82, tokens: 410000 },
      {
        scenarioId: 'ops-process-analysis',
        title: 'Анализ процесса',
        requests: 71,
        tokens: 340000,
      },
      { scenarioId: 'ops-sla-check', title: 'Проверка SLA', requests: 48, tokens: 230000 },
    ],
    feed: [
      {
        id: 'f4-1',
        scenarioId: 'ops-kpi-report',
        scenarioTitle: 'Операционный отчёт',
        fileName: 'kpi_апрель_2026.xlsx',
        time: '15:47',
        color: '#f59e0b',
      },
      {
        id: 'f4-2',
        scenarioId: 'ops-process-analysis',
        scenarioTitle: 'Анализ процесса',
        fileName: 'регламент_кредитования.pdf',
        time: '12:30',
        color: '#f59e0b',
      },
      {
        id: 'f4-3',
        scenarioId: 'ops-sla-check',
        scenarioTitle: 'Проверка SLA',
        fileName: 'sla_поддержка_Q1.pdf',
        time: 'Вчера',
        color: '#f59e0b',
      },
      {
        id: 'f4-4',
        scenarioId: 'ops-kpi-report',
        scenarioTitle: 'Операционный отчёт',
        fileName: 'операции_март_2026.xlsx',
        time: '10 апр',
        color: '#f59e0b',
      },
    ],
    monthTokens: [
      { month: 'Апрель', used: 980000 },
      { month: 'Март', used: 740000 },
      { month: 'Февраль', used: 520000 },
    ],
  },
  all: {
    userId: 'all',
    totalRequests: 671,
    requestsDelta: 46,
    tokensUsed: 3250000,
    tokenLimit: 6000000,
    documentsProcessed: 221,
    avgResponseTime: 5.1,
    activeDays: 21,
    weekActivity: [
      { day: 'Пн', count: 30 },
      { day: 'Вт', count: 55 },
      { day: 'Ср', count: 52 },
      { day: 'Чт', count: 76 },
      { day: 'Пт', count: 57 },
      { day: 'Сб', count: 10 },
      { day: 'Вс', count: 1 },
    ],
    scenarioStats: [
      { scenarioId: 'summarize-doc', title: 'Суммаризация', requests: 140, tokens: 730000 },
      { scenarioId: 'ops-kpi-report', title: 'Операционный отчёт', requests: 136, tokens: 700000 },
      { scenarioId: 'extract-tasks', title: 'Поручения', requests: 100, tokens: 460000 },
      {
        scenarioId: 'ops-process-analysis',
        title: 'Анализ процесса',
        requests: 95,
        tokens: 490000,
      },
      { scenarioId: 'business-reply', title: 'Деловой ответ', requests: 90, tokens: 390000 },
      { scenarioId: 'analyze-resume', title: 'Анализ резюме', requests: 47, tokens: 220000 },
      { scenarioId: 'compare-docs', title: 'Сравнение', requests: 87, tokens: 420000 },
    ],
    feed: [
      {
        id: 'f-1',
        scenarioId: 'summarize-doc',
        scenarioTitle: 'Суммаризация',
        fileName: 'договор_аренды_2024.pdf',
        time: '14:32',
        color: '#6366f1',
      },
      {
        id: 'f-2',
        scenarioId: 'extract-tasks',
        scenarioTitle: 'Поручения',
        fileName: 'протокол_совещания.docx',
        time: '11:10',
        color: '#6366f1',
      },
      {
        id: 'f-3',
        scenarioId: 'ops-kpi-report',
        scenarioTitle: 'Операционный отчёт',
        fileName: 'kpi_апрель_2026.xlsx',
        time: '15:47',
        color: '#f59e0b',
      },
      {
        id: 'f-4',
        scenarioId: 'business-reply',
        scenarioTitle: 'Деловой ответ',
        fileName: 'запрос_№145.pdf',
        time: 'Вчера',
        color: '#6366f1',
      },
      {
        id: 'f-5',
        scenarioId: 'compare-docs',
        scenarioTitle: 'Сравнение',
        fileName: 'договор_v1 vs v2',
        time: '12 апр',
        color: '#6366f1',
      },
      {
        id: 'f-6',
        scenarioId: 'analyze-resume',
        scenarioTitle: 'Анализ резюме',
        fileName: 'резюме_Соколова_ИВ.pdf',
        time: '10:15',
        color: '#10b981',
      },
      {
        id: 'f-7',
        scenarioId: 'ops-process-analysis',
        scenarioTitle: 'Анализ процесса',
        fileName: 'регламент_кредитования.pdf',
        time: '10 апр',
        color: '#f59e0b',
      },
    ],
    monthTokens: [
      { month: 'Апрель', used: 3250000 },
      { month: 'Март', used: 2620000 },
      { month: 'Февраль', used: 1860000 },
    ],
  },
};
